/** API route map: URLS.Controller.PayrollPayCode */
export const PayrollPayCode = {
      Name: 'PayrollPayCode/',
      Add: 'add',
      GetAll: 'get-all',
      Update: 'update',
      Delete: 'delete',
      SearchTaxType: 'search-taxtype',
      SearchPayCode: 'search-pay-code',
      AddAssignedPayCode: 'add-assigned-pay-code',
      GetPayCodeByClientId: 'get-pay-code-by-client-id',
      DeleteAssignedPayCode: 'delete-assigned-pay-code',
      SearPayCodeByClientId: 'search-pay-code-by-client-id',
      Import: 'import',
};
